export default __webpack_public_path__ + "media/src/assets/images/cut-0390811be883eb9f164b23be9f6ee522.png";